import RevokeVipModal from "./revoke-vip-modal.component";

export default RevokeVipModal;
